export default "__VITE_ASSET__DEZREYWX__"